import { Itemset, ItemsetResult } from "../store/viewmodels/ItemsetViewModel";
import { Task } from "../store/viewmodels/TaskViewModel";
import { Item } from "../store/viewmodels/ItemViewModel";
import { Student } from "../store/viewmodels/StudentViewModel";

export function getNextItemSetId(task: Task, currentItemsetId: string = "", activeItemsets: ItemsetResult[]): string {
    let iSetId: string = ""
    if (currentItemsetId.length === 0 && task.itemsets.length > 0) {
        for (let i = 0; i < task.itemsets.length; i++) {
            for (let j = 0; j < activeItemsets.length; j++) {
                if (task.itemsets[i].id === activeItemsets[j].id) {
                    iSetId = task.itemsets[i].id.toString()
                    return iSetId;
                }
            }
        }
    }

    let currentIndex = task.itemsets.findIndex(itemset => itemset.id.toString() === currentItemsetId)
    if (currentIndex > -1 && currentIndex + 1 < task.itemsets.length) {
        for (let i = currentIndex + 1; i < task.itemsets.length; i++) {
            for (let j = 0; j < activeItemsets.length; j++) {
                if (task.itemsets[i].id === activeItemsets[j].id) {
                    iSetId = task.itemsets[i].id.toString()
                    return iSetId;
                }
            }
        }
    }
    return ''
}

export function getNextItemId(itemset: Itemset, currentItemId: string = ""): string {
    if (currentItemId.length === 0 && itemset.items.length > 0) {
        return itemset.items[0].id.toString();
    }
    let currentIndex = itemset.items.findIndex(item => item.id.toString() === currentItemId)
    if (currentIndex > -1 && currentIndex + 1 < itemset.items.length) {
        return itemset.items[currentIndex + 1].id.toString();
    }
    return ''
}

export function getNextUrl(itemset: Itemset, item: Item, task: Task, activeItemsets: ItemsetResult[]) {
    let nextItemId: string = getNextItemId(itemset, item.id.toString());
    let nextUrl: string = '';

    if (nextItemId.length === 0) {
        nextUrl = `/student/tasks/`
    } else {
        nextUrl = `/content/tasks/${task.id}/itemsets/${itemset.id}/items/${nextItemId}`;
    }
    return nextUrl;
}

export function postCheck(itemset: Itemset, item: Item, task: Task, activeItemsets: ItemsetResult[]) {
    let nextItemId: string = getNextItemId(itemset, item.id.toString());
    let nextItemsetId: string = getNextItemSetId(task, itemset.id.toString(), activeItemsets);

    if (nextItemsetId.length === 0 && nextItemId.length === 0) return true
    else if (nextItemId.length === 0) return true
    else return false

}

export function isTaskDone(task: Task, student: Student): boolean {
    let results = student.results;

    if (results) {
        let itemsetIds = task.itemsets.map(itemset => itemset.id);
        let resultItemsetIds = results.map(result => result.itemset.id);

        for (let i: number = 0; i < itemsetIds.length; i++) {
            if (!resultItemsetIds.includes(itemsetIds[i])) return false;
        }
    }
    return true;

}